import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_410 implements Validator {

	public static id = 'CTRL_410';
	private message = 'error.ctr_410';


	public LOG: LogService = new LogService(CTRL_410);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_410.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const dateEnvoiInvitationWithStepId = map.get(ctrl.value.rgCtrls.dateEnvoiInvitation);
				const dateReceptCandidatureWithStepId = map.get(ctrl.value.rgCtrls.dateReceptCandidature);
				const dateEnvoiInvitationCtrl = form.controls[dateEnvoiInvitationWithStepId];
				const dateReceptCandidatureCtrl = form.controls[dateReceptCandidatureWithStepId];

				if (dateReceptCandidatureCtrl.value !== 'yyyy-MM-dd' && dateReceptCandidatureCtrl.value !=="" && dateEnvoiInvitationCtrl.value !== 'yyyy-MM-dd' && dateEnvoiInvitationCtrl.value !=="" && new Date(dateReceptCandidatureCtrl.value).getTime() > new Date(dateEnvoiInvitationCtrl.value).getTime()) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
			}
		}
	}
}
